<script setup lang="ts">import { ref as _ref } from 'vue';

import BotFooter from '@/components/BotFooter.vue'
import TopNav from '@/components/TopNav.vue'
import { useLangTools } from '@/lang'
import { onServerPrefetch, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const { $tdb } = useLangTools(useRouter())
const route = useRoute()
let page = _ref<Record<string, any>>()

async function fetch() {
	const { legalPages } = await import('@/data/legalPages')
	page.value = legalPages.find(page => $tdb(page, 'slug') === route.params.legal_slug)
}

watch(route, fetch, { immediate: true })
onServerPrefetch(fetch)
</script>

<template>
	<div>
		<div class="act_oval" />
		<TopNav />
		<div class="page-wrap relative">
			<div class="act_w1170 side-title">
				<div class="white-box">
					<h1 class="playfair act_txt60 act_no-marg balance">
						{{ $tdb(page, 'name') }}
					</h1>
					<div v-html="$tdb(page, 'body')" />
				</div>
			</div>
		</div>
		<BotFooter />
	</div>
</template>
